@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faBookmark"></fa-icon>
          {{ 'REFERENCES.SAVE_MODAL.TITLE' | translate }}
        </h3>
        <button class="close-btn" (click)="onClose()" type="button" [disabled]="loading">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="onSave()" autocomplete="off">
          <div class="form-group">
            <label for="referenceName">{{ 'REFERENCES.SAVE_MODAL.NAME_LABEL' | translate }}</label>
            <input
              id="referenceName"
              type="text"
              [(ngModel)]="name"
              name="referenceName"
              [disabled]="loading"
              required
              maxlength="255"
              [placeholder]="'REFERENCES.SAVE_MODAL.NAME_PLACEHOLDER' | translate"
              class="form-control"
              autocomplete="off"
            />
          </div>
          <div class="form-actions">
            <button type="button" class="cancel-button" (click)="onClose()" [disabled]="loading">
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button type="submit" class="save-button" [disabled]="loading || !name.trim()">
              <fa-icon [icon]="faCheck"></fa-icon>
              {{ 'BUTTON.SAVE' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
